<ng-container *ngIf="chatLink; else LinkButton">
    <a tabindex="0" [class]="childClass" href="javascript:void(0)" (click)="triggerChat()">
        <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
    </a>
</ng-container>
<ng-template #LinkButton>
    <ng-container *ngIf="internalLink || externalLink || documentLink; else noLinkTemplate">
        <ng-container *ngIf="internalLink then internal else external"></ng-container>
    </ng-container>
    <ng-template #internal>
        <ng-container *ngIf="fragment; else noFragment">
            <a tabindex="0" [class]="childClass" [target]="target === '_blank' ? target : '_self'" [routerLink]="internalLink ? ['/' + internalLink] : []" [fragment]="fragment">
                <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
            </a>
        </ng-container>
        <ng-template #noFragment>
            <a tabindex="0" [class]="childClass" [target]="target === '_blank' ? target : '_self'" [routerLink]="['/' + internalLink]" queryParamsHandling="preserve">
                <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
            </a>
        </ng-template>
    </ng-template>
    <ng-template #external>
        <ng-container *ngIf="externalLink; else document">
            <a tabindex="0" [class]="childClass" [target]="target === '_blank' ? target : '_self'" [href]="externalLink">
                <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
            </a>
        </ng-container>
        <ng-template #document>
            <a tabindex="0" [class]="childClass" [target]="target == '_blank' ? target : '_self'" [href]="documentLink">
                <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
            </a>
        </ng-template>
    </ng-template>
    <ng-template #noLinkTemplate>
        <ng-container *ngIf="fragment">
            <a
                tabindex="0"
                [class]="childClass"
                [target]="target === '_blank' ? target : '_self'"
                [routerLink]="internalLink ? ['/' + internalLink] : []"
                [fragment]="fragment"
                queryParamsHandling="preserve"
            >
                <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
            </a>
        </ng-container>
        <ng-container *ngIf="!fragment">
            <span [class]="childClass">
                <ng-container *ngTemplateOutlet="linkInnerContent"></ng-container>
            </span>
        </ng-container>
    </ng-template>
</ng-template>

<ng-template #linkInnerContent>
    <ng-container *ngIf="linkContent; else  linkText" >
        <ng-container *ngTemplateOutlet="linkContent"></ng-container>
    </ng-container>
    <ng-template #linkText>{{linkTitle}}</ng-template>
</ng-template>
